import { useSyncExternalStore } from 'react';

const KEY = 'mc.branch';
const listeners = new Set<() => void>();

function read(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

/** Sucursal elegida en la barra superior: se recuerda por navegador y la agenda la sigue. */
export function setActiveBranch(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // sin almacenamiento: vale para esta pestaña
  }
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** La sucursal elegida, o la primera de la lista si no hay una válida guardada. */
export function useActiveBranch(branches: readonly { id: string }[]): string {
  const stored = useSyncExternalStore(subscribe, read, read);
  return branches.some((b) => b.id === stored) ? stored : (branches[0]?.id ?? '');
}

/**
 * Las sucursales donde el usuario cobra, abre caja y presupuesta (FB-02): Recepción ve y agenda
 * en todas, pero las que no son suyas vienen `agendaOnly`.
 */
export function ownBranches<T extends { agendaOnly?: boolean }>(branches: readonly T[]): T[] {
  return branches.filter((b) => b.agendaOnly !== true);
}
